import { component } from 'picoapp';
import GetLinkedProductsData from 'utils/get-linked-products';
import { image } from 'utils/image';

const linkedProductTemplate = (mainProductId, product) => {
  let cssClass = 'bg-neutral-light-grey aspect-ratio aspect-ratio--4/5 border-2';

  if (mainProductId === product.productId) {
    cssClass += ' border-black';
  } else {
    cssClass += ' border-neutral-medium-grey hover:border-black';
  }

  const htmlTemplate = `
    <div class="p-1 w-1/5">
    <a
      class="${cssClass}"
      href="${product.url}"
      data-title="${product.color}"
      data-linked-product
    >
      ${image(product.image)}>
    </a>
  </div>`;

  return htmlTemplate;
};

const changeTitle = (node) => {
  const currentTitle = node.querySelector('[data-current-title]') as HTMLElement;
  const linkedProducts = node.querySelectorAll('[data-linked-product]');

  const initCurrentTitle = () => {
    const { initialValue } = currentTitle.dataset;

    linkedProducts.forEach((linkedProduct) => {
      const { title } = linkedProduct.dataset;

      linkedProduct.addEventListener('mouseover', () => {
        currentTitle.textContent = title;
      });

      linkedProduct.addEventListener('mouseleave', () => {
        currentTitle.textContent = initialValue;
      });
    });
  };

  const init = () => {
    initCurrentTitle();
  };

  init();
};

export default component(async (node) => {
  document.addEventListener('linkedProductsDataLoaded', () => {
    const productId: number = parseInt(node.getAttribute('data-product-id'), 10);
    const sku = node.getAttribute('data-sku');
    const referance = sku.split('-')[0];
    const linkedPeoducts = JSON.parse(sessionStorage.getItem('linked-products'))?.[referance];
    const productsContainer = node.querySelector('[data-render-products]');

    if (!linkedPeoducts && !productsContainer) return;

    productsContainer.innerHTML = linkedPeoducts.map((product) => linkedProductTemplate(productId, product)).join('');

    changeTitle(node);
    node.removeAttribute('hidden');
  });

  /**
 * Checking if storedProductSkusInSession exist, and is not an empty object
 */
  if (JSON.parse(sessionStorage.getItem('linked-products')) && Object.keys(JSON.parse(sessionStorage.getItem('linked-products'))).length > 0) {
    document.dispatchEvent(new CustomEvent('linkedProductsDataLoaded'));
  } else {
    // eslint-disable-next-line no-new, no-void
    void new GetLinkedProductsData();
  }
});
